<template>
    <div class="tags-all">
        <div class="bread-list">
            <span class="with-hand" @click="toHome">{{ $t("home") }}</span>
            <iconSymbol class="arrow-next" name="arrow-next" />
            <span>{{ $t("all") }}</span>
        </div>
        <div class="tags-list">
            <div class="tags-item" v-for="i in tagList" :key="i.id" @click="setTagId(i.tag_id)">
                <img :src="i.show_photo" alt="" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    @Component({})
    export default class tagsSearch extends Vue {
        value = "";
        toHome() {
            if (this.isPC) {
                (<any>window).$qt.jsCallBackToHomePage?.();
            }
        }
        get tagList() {
            return this.$store.state.tagList;
        }
        setTagId(data: number) {
            this.$store.commit("toAlbumID", data);
        }
    }
</script>
<style lang="less" scoped>
    .tags-all {
        padding-top: 16px;
        .bread-list {
            padding: 0 24px;
            display: flex;
            align-items: center;
            .arrow-next {
                width: 20px;
                height: 20px;
                color: var(--fontSearchTinyColor);
            }
            span {
                font-size: 16px;
                line-height: 28px;
                height: 28px;
                display: block;
                padding: 0 4px;
                border-radius: 4px;
                &:not(:last-child) {
                    color: var(--fontSearchTinyColor);
                    &:hover {
                        color: var(--fontSearchColor);
                        background: var(--breadBgColor);
                    }
                }
                &:last-child {
                    color: var(--fontSearchColor);
                }
            }
        }

        .tags-list {
            padding: 24px;
            grid-template-columns: repeat(10, 1fr);
            display: grid;
            grid-column-gap: 24px;
            grid-row-gap: 24px;
            @media screen and (max-width: 768px) {
                grid-column-gap: 16px;
                grid-row-gap: 16px;
            }
            .tags-item {
                overflow: hidden;
                cursor: pointer;
                img {
                    display: block;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
        @media screen and (max-width: 3840px) {
            .tags-list {
                grid-template-columns: repeat(10, 1fr);
            }
        }

        @media screen and (max-width: 3520px) {
            .tags-list {
                grid-template-columns: repeat(9, 1fr);
            }
        }

        @media screen and (max-width: 3200px) {
            .tags-list {
                grid-template-columns: repeat(8, 1fr);
            }
        }

        @media screen and (max-width: 2880px) {
            .tags-list {
                grid-template-columns: repeat(7, 1fr);
            }
        }

        @media screen and (max-width: 2560px) {
            .tags-list {
                grid-template-columns: repeat(6, 1fr);
            }
        }

        @media screen and (max-width: 1920px) {
            .tags-list {
                grid-template-columns: repeat(4, 1fr);
            }
        }

        @media screen and(max-width: 1432px) {
            .tags-list {
                grid-template-columns: repeat(3, 1fr);
            }
        }

        @media screen and(max-width: 768px) {
            .tags-list {
                grid-template-columns: repeat(2, 1fr);
            }
        }
        @media screen and(max-width: 768px) {
            .tags-list {
                grid-template-columns: repeat(2, 1fr);
            }
        }
        @media screen and(max-width: 375px) {
            .tags-list {
                grid-template-columns: repeat(1, 1fr);
            }
        }
    }
</style>
<i18n>
{
    "zh": {
        "title": "营销模板集合",
        "subTitle": "探索精选集，从中获得灵感",
        "templates": "模板社区",
        "all": "所有类别",
        "home": "返回首页",
        "trendCollection": "热门类别"
    },
    "en": {
        "title": "Marketing Template Collections",
        "subTitle": "Explore Editor’s featured collections to get some inspiration from Edrawers",
        "templates": "Templates Community",
        "all": "All Collections",
        "home": "Home",
        "trendCollection": "Trending Collections"
    },
    "jp": {
        "title": "使える豊富なテンプレート群",
        "subTitle": "業界に特化した豊富なテンプレートを搭載しているので、脳内イメージを高速で具現化出来ます",
        "templates": "テンプレートコミュニティ",
        "all": "すべてのカテゴリ",
        "home": "ホーム",
        "trendCollection": "人気カテゴリ"
    },
    "fr": {
        "title": "Collections de modèles de marketing",
        "subTitle": "Explorez les collections en vedette de l'éditeur pour vous inspirer d'Edrawers",
        "templates": "Communauté des Modèles",
        "all": "Toutes les Collections",
        "home": "Accueil",
        "trendCollection": "Collections tendance"
    },
    "de": {
        "title": "Sammlungen von Marketingvorlagen",
        "subTitle": "Entdecken Sie die von Editor vorgestellten Kollektionen, um sich von Edrawers inspirieren zu lassen",
        "templates": "Schablonen Gemeinschaft",
        "all": "Alle Sammlungen",
        "home": "Start",
        "trendCollection": "Aktuelle Kollektionen"
    },
    "es": {
        "title": "Colecciones de plantillas de marketing",
        "subTitle": "Explore las colecciones destacadas del Editor para inspirarse en Edrawers",
        "templates": "Comunidad de Plantillas",
        "all": "Todas las Colecciones",
        "home": "Pantalla de Inicio",
        "trendCollection": "Colecciones de Tendencias"
    },
    "pt": {
        "title": "Coleções de modelos de marketing",
        "subTitle": "Explore as coleções em destaque do Editor para se inspirar no Edrawers",
        "templates": "Comunidade de Modelos",
        "all": "Todas as coleções",
        "home": "Início",
        "trendCollection": "Coleções de Tendências"
    },
    "it": {
        "title": "Raccolte di modelli di marketing",
        "subTitle": "Esplora le raccolte in primo piano di Editor per trarre ispirazione da Edrawers",
        "templates": "Comunità di Modelli",
        "all": "Tutte le Collezioni",
        "home": "Casa",
        "trendCollection": "Collezioni di Tendenza"
    },
    "tw": {
        "title": "營銷模板集合",
        "subTitle": "探索精選集，從中獲得靈感",
        "templates": "範本社區",
        "all": "所有類別",
        "home": "轉到主頁",
        "trendCollection": "熱門類別"
    },
    "kr": {
        "title": "마케팅 템플릿 컬렉션",
        "subTitle": "컬렉션을 탐색하고 영감을 얻으십시오.",
        "templates": "템플릿 갤러리",
        "all": "모든 컬랙션",
        "home": "메인 화면 가기",
        "trendCollection": "인기 컬랙션"
    },
    "id": {
        "title": "Koleksi Templat Pemasaran",
        "subTitle": "Jelajahi koleksi unggulan Editor untuk mendapatkan inspirasi dari para pengguna Edraw",
        "templates": "Komunitas Templat",
        "all": "Semua Koleksi",
        "home": "Beranda",
        "trendCollection": "Koleksi yang sedang Tren"
    }
}
</i18n>
